import React, { Component } from 'react';
import Radium from 'radium';
import Colors from '../utils/colors';
import Breakpoints from '../utils/breakpoints';
import Link from 'gatsby-link'
import {prettifyUrl, getLang} from "../utils/util-functions";

class BlueSingleBox extends Component {

  shortenText(text){
    return text && text.length > 32 ? text.substr(0, 32)+".." : text;
  }

  go(url) {
    if (url.startsWith('http')) {
      window.location = url
    } else {
      this.props.history.push(url);
    }
    return false
  }

  render() {
    //Need to add key={x} so Radium works properly
    return (
        <div style={styles.main}>
          <div className="row" style={styles.text} key={1}>
            <div className="col-xs-12 hidden-sm hidden-md hidden-lg" style={styles.nameMobile} onClick={() => this.props.clickExtraText(prettifyUrl(this.props.name))}>
              <span style={styles.textMobile}>{this.props.name}</span> <i style={styles.nameMobileIcon} className="glyphicon glyphicon-chevron-right pull-right"></i>
            </div>
            <div className="col-xs-3 hidden-xs" onClick={() => this.props.clickExtraText(prettifyUrl(this.props.name))}>{this.props.name}</div>
            <div className="col-xs-3 hidden-xs" key={2} onClick={() => this.props.clickExtraText(prettifyUrl(this.props.name))}>{this.props.extraText}</div>
            <div className="col-xs-3 hidden-xs"><a onClick={() => this.go(this.props.buttonLink)} href={this.props.buttonLink} style={styles.button} key={3}>{this.shortenText(this.props.buttonText)}</a></div>
            <div className="col-xs-3 hidden-xs">{this.props.phoneText} <a style={styles.phone} key={4} href={"tel:"+this.props.phone}>{this.props.phone}</a> </div>
          </div>
        </div>
    );
  }
}

const styles = {
  main: {
    backgroundColor: Colors.darkBrown,
    padding: 10,
    marginTop: 10,
    borderRadius: Breakpoints.borderRadius,
    ':hover': {
      backgroundColor: Colors.lightBrown
    },
    [Breakpoints.media.siteUnderPadWidth]: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  button: {
    padding: 8,
    display: 'block',
    backgroundColor: '#ffffff',
    textAlign: 'center',
    color: Colors.darkBlue,
    borderRadius: 25,
    opacity: '0.8',
    width: '100%',
    ':hover': {
      cursor: 'pointer'
    }
  },
  text: {
    color: Colors.darkBlue,
    lineHeight: 1.5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 5,
    ':hover': {
      cursor: 'pointer'
    },
    [Breakpoints.media.siteUnderPadWidth]: {
      display: 'block',
      textAlign: 'left',
    },
  },
  textMobile: {
    [Breakpoints.media.siteUnderPadWidth]: {
      marginTop: 7,
      display: 'inline-block'
    }
  },
  nameMobile: {
    [Breakpoints.media.siteUnderPadWidth]: {
      width: '100%',
    }
  },
  nameMobileIcon: {
    [Breakpoints.media.siteUnderPadWidth]: {
      fontSize: 16,
      marginTop: 6
    }
  },
  phone: {
    color: Colors.darkBlue,
    textDecoration: 'underline',
    ':hover': {
      cursor: 'pointer'
    }
  }
};

export default Radium(BlueSingleBox);


// WEBPACK FOOTER //
// ./src/components/FullPageBlueItem.js